import { render, staticRenderFns } from "./CategoryProductList.vue?vue&type=template&id=59507b32&scoped=true"
import script from "./CategoryProductList.vue?vue&type=script&lang=ts"
export * from "./CategoryProductList.vue?vue&type=script&lang=ts"
import style0 from "./CategoryProductList.vue?vue&type=style&index=0&id=59507b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59507b32",
  null
  
)

export default component.exports